import * as React from 'react'
import IconHome from '@material-ui/icons/Home'
import IconPlay from '@material-ui/icons/PlayArrow'
import SettingsIcon from '@material-ui/icons/Settings'

export interface TSidebarNavItem {
  name: string
  icon: any
  url: string
  requiredRole?: number
}

export interface TSidebarNavSection {
  sectionName: string
  items: TSidebarNavItem[]
}

export type TSidebarNav = TSidebarNavSection[]

export const sidebarNav: TSidebarNav = [
  {
    sectionName: '',
    items: [
      {
        name: 'Introduction',
        icon: <IconHome />,
        url: '/',
      },
      {
        name: 'Simulation',
        icon: <IconPlay />,
        url: '/simulation',
      },
      {
        name: 'Explore Model',
        icon: <SettingsIcon />,
        url: '/explore',
      },
    ],
  },
]
